import { gray, red, white } from '@kmns-internal/furikake/tokens'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { FC } from 'react'
import { TableSectionView } from './parseTableSection'
import {
  bodyCellSx,
  bodyFirstCellSx,
  bodyRowHeadingCellSx,
  headerCellSx,
  headerFirstCellSx,
  headerRowHeadingCellSx,
  inactiveCellSx,
} from './styles'
import { TableSectionBodyCell } from './TableSectionBodyCell'

type Props = {
  view: TableSectionView
  goPreviewPhoto: (imageUrls: string[], selectedImageIndex: number) => void
}

export const TableSectionTable: FC<Props> = ({ view, goPreviewPhoto }) => (
  <TableContainer
    sx={{
      pb: 1,
      '&::-webkit-scrollbar': { height: 16, backgroundColor: white },
      '&::-webkit-scrollbar-track': { backgroundColor: white },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: gray[4],
        borderTop: `solid 4px ${white}`,
        borderBottom: `solid 4px ${white}`,
        borderLeft: `solid 8px ${white}`,
        borderRight: `solid 8px ${white}`,
      },
    }}
  >
    <Table sx={{ width: 'max-content', borderCollapse: 'separate' }}>
      <TableHead>
        <TableRow>
          {/* クリップボードからexcelへコピペした際に表の段組が崩れてしまうので、対策としてスペースを入れておく */}
          <TableCell sx={headerFirstCellSx}>&nbsp;</TableCell>
          {view.headingLabel !== undefined && (
            <TableCell sx={headerRowHeadingCellSx}>
              {view.headingLabel}
            </TableCell>
          )}
          {view.columnNodes.map(columnNode => (
            <TableCell key={columnNode.id} sx={headerCellSx}>
              <Box
                component="span"
                sx={{ position: 'relative', display: 'inline-block' }}
              >
                {columnNode.question?.isRequired === 1 && (
                  <Box
                    component="span"
                    sx={{
                      position: 'absolute',
                      top: -2,
                      left: -8,
                      height: 8,
                      width: 8,
                      borderRadius: '50%',
                      bgcolor: red[6],
                    }}
                  />
                )}
                {columnNode.question?.name}
              </Box>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {view.rows.map(row => (
          <TableRow key={row.rowNode.id}>
            {/* 行番号は表全体での通し番号。逸脱フィルタで絞り込んでも全体表示と一致する */}
            <TableCell sx={bodyFirstCellSx}>{row.rowNumber}</TableCell>
            {view.headingLabel !== undefined && (
              <TableCell sx={bodyRowHeadingCellSx}>{row.heading}</TableCell>
            )}
            {row.cells.map((cell, columnIndex) => {
              const { id, question } = cell.questionNode
              // 祖先の条件を満たさない分岐質問のセルは回答対象外なので「ー」を出す。
              if (!cell.active) {
                return (
                  <TableCell key={id} sx={inactiveCellSx}>
                    ー
                  </TableCell>
                )
              }
              if (!question) {
                return <TableCell key={id} sx={bodyCellSx} />
              }
              const isTimeDisplayed =
                view.columnNodes[columnIndex]?.question?.isTimeDisplayed === 1
              return (
                <TableSectionBodyCell
                  key={id}
                  question={question}
                  isTimeDisplayed={isTimeDisplayed}
                  goPreviewPhoto={goPreviewPhoto}
                />
              )
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)
